// Firebase Client SDK configuration
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDl2LT1gnfizvVb7n3XxNiu10FQ3d2kqOU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "xsquarehub.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "xsquarehub",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "xsquarehub.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "706213509400",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:706213509400:web:052407c9548b851b9a466d",
  measurementId: "G-K5FSWE488Y"
};

// Check if valid configuration exists
export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey &&
  firebaseConfig.authDomain &&
  firebaseConfig.projectId
);

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
